import { Box } from "@mui/material"
import type { CSSProperties } from "react"
import { IconUrlContainer } from "./IconUrls/IconUrlContainer"

type GiftCardIconProps = {
  size?: number | string
  color?: CSSProperties["color"]
  style?: CSSProperties
}

const VIEWBOX_ASPECT_RATIO = "54 / 30"

export const GiftCardIcon = ({
  size = 24,
  color = "currentColor",
  style = {},
}: GiftCardIconProps) => (
  <Box
    position="relative"
    sx={{
      height: style.height ?? style.width ?? size,
      aspectRatio: VIEWBOX_ASPECT_RATIO,
      flexShrink: 0,
    }}
  >
    <Box
      component="svg"
      viewBox="0 0 54 30"
      width="100%"
      height="100%"
      sx={{ position: "absolute", inset: 0 }}
    >
      <use href="/icons/gift-card-envelope.svg#giftCardEnvelope" />
    </Box>
    <IconUrlContainer
      url="/icons/gift-card-detail.svg"
      color={color}
      style={{ position: "absolute", inset: 0, width: "100%", height: "100%" }}
    />
  </Box>
)
